
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { message } from "antd";
// Import components from menucomponent folder
import Header from "../../Authentication/menucomponent/Header";
import CategoryNav from "../../Authentication/menucomponent/CategoryNav";
import OffersSection from "../../Authentication/menucomponent/OffersSection";
import SearchBar from "../../Authentication/menucomponent/SearchBar";
import DietFilter from "../../Authentication/menucomponent/DietFilter";
import CategorySection from "../../Authentication/menucomponent/CategorySection";
import BottomBar from "../../Authentication/menucomponent/BottomBar";
import ItemDetailsModal from "../../Authentication/menucomponent/ItemDetailsModal";
import CartModal from "../../Authentication/menucomponent/CartModal";
import AskPopupModal from "../../Authentication/menucomponent/AskPopupModal";
import ContactModal from "../../Authentication/menucomponent/ContactModal"; // New import
import Loader from "../../Authentication/menucomponent/Loader";
import ErrorMessage from "../../Authentication/menucomponent/ErrorMessage";
/* --- keep or replace offersData as you like --- */
const defaultOffersData = [
  { name: "Upto ₹100 Cashback", description: "Min. order ₹350" },
  { name: "20% Off on Appetizers", description: "Valid on select items" },
  { name: "Free Drink with Main Course", description: "Limited time" },
];
const defaultColors = {
  bg: "#f3f4f6",
  card: "#ffffff",
  text: "#1f2937",
  muted: "#6b7280",
  accent: "#6bb14b",
  addBtnBg: "#000000",
  veg: "#28a745",
  nonVeg: "#dc3545",
  offerColors: ["#fef3c7", "#e9d5ff", "#dbeafe", "#d1fae5", "#dbeafe", "#fef3c7", "#e9d5ff", "#d1fae5", "#dbeafe", "#fef3c7"],
  footerBg: "#e0e7ff",
  captionColor: "#2d3748",
  separatorColor: "#4a90e2",
};
const defaultColValue = 3;
const defaultColMobileValue = 2;
export default function DigitalMenu({ code, type, onBack }) {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [config, setConfig] = useState(null);
  const [categoriesData, setCategoriesData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [expandedCategories, setExpandedCategories] = useState({}); // Default empty, meaning collapsed
  const [expandedSubCategories, setExpandedSubCategories] = useState({});
  const [selectedDiet, setSelectedDiet] = useState("All");
  const [menuItems, setMenuItems] = useState([]);
  const [cart, setCart] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showCart, setShowCart] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [showOffers, setShowOffers] = useState(true);
  const [showAskPopup, setShowAskPopup] = useState(false);
  const [occasion, setOccasion] = useState("");
  const [budget, setBudget] = useState("");
  const [sharingStyle, setSharingStyle] = useState("sharing");
  const [vegCount, setVegCount] = useState(0);
  const [nonVegCount, setNonVegCount] = useState(0);
  const [preferences, setPreferences] = useState("");
  const [spiceLevel, setSpiceLevel] = useState("medium");
  const [cuisine, setCuisine] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 820);
  const [colorsState, setColorsState] = useState(defaultColors);
  const [offersDataState, setOffersDataState] = useState(defaultOffersData);
  const [colValueState, setColValueState] = useState(defaultColValue);
  const [colMobileValueState, setColMobileValueState] = useState(defaultColMobileValue);
  const [showMenuCaption, setShowMenuCaption] = useState(false);
  const [menuCaptionText, setMenuCaptionText] = useState("MENU");
  const [menuCaptionSize, setMenuCaptionSize] = useState("3.8rem");
  const [showLogo, setShowLogo] = useState(true);
  const [showAskMe, setShowAskMe] = useState(true);
  const [showContactInfo, setShowContactInfo] = useState(false);
  const [workingHours, setWorkingHours] = useState({
    Monday: "00:00 - 23:59",
    Tuesday: "00:00 - 23:59",
    Wednesday: "00:00 - 23:59",
    Thursday: "00:00 - 23:59",
    Friday: "00:00 - 23:59",
    Saturday: "00:00 - 23:59",
    Sunday: "00:00 - 23:59",
  });
  const [socialLinks, setSocialLinks] = useState([]);
  const [showContactModal, setShowContactModal] = useState(false); // New state
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 820);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    if (!code) {
      setError("Invalid code");
      setLoading(false);
      return;
    }
    const fetchData = async () => {
      try {
        const apiURL = "https://api.netshineoffice.com/api";
        const token = localStorage.getItem("token");
        const response = await axios.post(`${apiURL}/pos/digital-menu/`, { code }, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 200) {
          const data = response.data;
          setConfig(data.config);
          setCategoriesData(data.categories);
          const catMap = {};
          data.categories.forEach(cat => {
            catMap[cat.category_id] = cat.name;
          });
          const allMenuItems = [];
          const traverse = (cats) => {
            cats.forEach(cat => {
              cat.menus.forEach(menu => {
                allMenuItems.push({
                  name: menu.name,
                  description: menu.description,
                  price: parseFloat(menu.price_standard) || 0.0,
                  image: menu.image_url || 'https://netshine-assets.blr1.cdn.digitaloceanspaces.com/app-assets/no-menu.png',
                  diet: menu.is_veg ? "veg" : "non-veg",
                  kidFriendly: false,
                  category: cat.parent_id ? catMap[cat.parent_id] : cat.name,
                  subCategory: cat.parent_id ? cat.name : null
                });
              });
              if (cat.children) traverse(cat.children);
            });
          };
          traverse(data.categories);
          setMenuItems(allMenuItems);
          // Apply config
          if (data.config) {
            setColorsState({ ...defaultColors, ...data.config.colors });
            setOffersDataState(data.config.offers || defaultOffersData);
            setShowOffers(data.config.showOffers);
            setColValueState(data.config.colDesktop || defaultColValue);
            setColMobileValueState(data.config.colMobile || defaultColMobileValue);
            setShowMenuCaption(data.config.showMenuCaption);
            setMenuCaptionText(data.config.menuCaptionText || "MENU");
            setMenuCaptionSize(data.config.menuCaptionSize || "3.8rem");
            setShowLogo(data.config.showLogo);
            setShowAskMe(data.config.showAskMe);
            setShowContactInfo(data.config.showContactInfo);
            setWorkingHours(data.config.workingHours || workingHours);
            setSocialLinks(data.config.socialLinks || []);
          }
        } else {
          setError("Invalid code");
        }
      } catch (err) {
        setError(err.response?.data?.error || "Invalid code");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [searchParams]);
  useEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.querySelector('.menu-topbar');
      if (header) {
        setHeaderHeight(header.offsetHeight);
      }
    };
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
    const observer = new MutationObserver(updateHeaderHeight);
    observer.observe(document.querySelector('.menu-topbar') || document.body, { childList: true, subtree: true, attributes: true });
    return () => {
      window.removeEventListener('resize', updateHeaderHeight);
      observer.disconnect();
    };
  }, []);
  const parentCategories = categoriesData.filter(cat => cat.parent_id === null).map(cat => cat.name).sort();
  const categories = ["All", ...parentCategories];
  const diets = ["All", "Veg", "Non-Veg"];
  const filteredMenu = menuItems.filter((item) => {
    const matchesCategory = selectedCategory === "All" || item.category === selectedCategory;
    const matchesSearch = item.name.toLowerCase().includes(searchTerm.trim().toLowerCase());
    const matchesDiet = selectedDiet === "All" || item.diet === selectedDiet.toLowerCase();
    return matchesCategory && matchesSearch && matchesDiet;
  });
  const addToCart = (item, qty = 1) => {
    setCart((prev) => {
      const ex = prev.find((p) => p.item.name === item.name);
      if (ex) return prev.map((p) => (p.item.name === item.name ? { ...p, quantity: p.quantity + qty } : p));
      return [...prev, { item, quantity: qty }];
    });
  };
  const removeFromCart = (item, qty = 1) => {
    setCart((prev) => {
      const ex = prev.find((p) => p.item.name === item.name);
      if (!ex) return prev;
      const newQty = ex.quantity - qty;
      if (newQty <= 0) return prev.filter((p) => p.item.name !== item.name);
      return prev.map((p) => (p.item.name === item.name ? { ...p, quantity: newQty } : p));
    });
  };
  const getCartQuantity = (name) => {
    const c = cart.find((p) => p.item.name === name);
    return c ? c.quantity : 0;
  };
  const handleItemClick = (item) => {
    setSelectedItem(item);
    setShowDetails(true);
  };
  const handleCartClick = () => {
    setShowCart(true);
  };
  const closeCart = () => {
    setShowCart(false);
  };
  const closeDetails = () => {
    setShowDetails(false);
  };
  const closeAskPopup = () => {
    setShowAskPopup(false);
  };
  const handleAskConfirm = () => {
    // For now, add random items
    if (menuItems.length > 0) {
      const randomItems = menuItems.sort(() => 0.5 - Math.random()).slice(0, 3);
      randomItems.forEach((item) => {
        const randomQty = Math.floor(Math.random() * 3) + 1;
        addToCart(item, randomQty);
      });
    }
    setShowAskPopup(false);
    setShowCart(true);
  };
  const handleContactClick = () => {
    setShowContactModal(true);
  };
  const closeContact = () => {
    setShowContactModal(false);
  };
  const totalItems = cart.reduce((s, c) => s + c.quantity, 0);
  const scrollLeft = () => {
    const container = document.querySelector(".menu-category-pills");
    if (container) {
      const newScroll = Math.max(container.scrollLeft - 200, 0);
      container.scrollTo({ left: newScroll, behavior: 'smooth' });
    }
  };
  const scrollRight = () => {
    const container = document.querySelector(".menu-category-pills");
    if (container) {
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      const newScroll = Math.min(container.scrollLeft + 200, scrollWidth - clientWidth);
      container.scrollTo({ left: newScroll, behavior: 'smooth' });
    }
  };
  const handleCategoryClick = (cat) => {
    setSelectedCategory(cat);
    if (cat !== "All") {
      setExpandedCategories(prev => ({ ...prev, [cat]: true })); // Expand the selected main category
    }
    const container = document.querySelector(".menu-category-pills");
    if (container) {
      const pill = Array.from(container.getElementsByTagName('button')).find(btn => btn.textContent === cat);
      if (pill) {
        pill.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
    }
  };
  const handleDietClick = (diet) => {
    setSelectedDiet(diet);
  };
  const toggleCategory = (cat) => {
    setExpandedCategories(prev => ({ ...prev, [cat]: !prev[cat] }));
  };
  const toggleSubCategory = (parent, sub) => {
    setExpandedSubCategories(prev => ({
      ...prev,
      [parent]: {
        ...prev[parent],
        [sub]: ! (prev[parent]?.[sub] || false)
      }
    }));
  };
  const currentColValue = isMobile ? colMobileValueState : colValueState;
  const displayParents = selectedCategory === "All" ? parentCategories : [selectedCategory];
  const shareMenu = async () => {
    const url = window.location.href;
    const shareData = {
      title: 'Check out this menu!',
      text: 'Here\'s the link to the digital menu',
      url,
    };
    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.error('Sharing failed', err);
      }
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(url);
        message.success('Menu link copied to clipboard!');
      } catch (err) {
        console.error('Clipboard copy failed', err);
      }
    } else {
      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      message.success('Menu link copied!');
    }
  };
  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <ErrorMessage message={error} />;
  }
  if (menuItems.length === 0) {
    return <ErrorMessage message="No Menu configured" />;
  }
  return (
    <div className="menu-digital-menu-root">
      {type === "reservation" && (
        <button
          className="menu-close-btn"
          onClick={onBack || (() => window.history.back())}
        >
          ✕
        </button>
      )}

      <Header
        showLogo={showLogo}
        showMenuCaption={showMenuCaption}
        menuCaptionText={menuCaptionText}
        menuCaptionSize={menuCaptionSize}
      />
      <CategoryNav
        categories={categories}
        selectedCategory={selectedCategory}
        handleCategoryClick={handleCategoryClick}
        scrollLeft={scrollLeft}
        scrollRight={scrollRight}
        headerHeight={headerHeight}
      />
      <main className="menu-container" style={{ marginTop: `${headerHeight}px`, marginBottom: '80px' }}>
        {showOffers && offersDataState?.length > 0 && (
          <OffersSection offersDataState={offersDataState} colorsState={colorsState} />
        )}
        <SearchBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          filteredMenuLength={filteredMenu.length}
        />
        <DietFilter
          diets={diets}
          selectedDiet={selectedDiet}
          handleDietClick={handleDietClick}
        />
        <CategorySection
          displayParents={displayParents}
          filteredMenu={filteredMenu}
          expandedCategories={expandedCategories}
          toggleCategory={toggleCategory}
          expandedSubCategories={expandedSubCategories}
          toggleSubCategory={toggleSubCategory}
          currentColValue={currentColValue}
          handleItemClick={handleItemClick}
          colorsState={colorsState}
          getCartQuantity={getCartQuantity}
          addToCart={addToCart}
          removeFromCart={removeFromCart}
        />
        {filteredMenu.length === 0 && <div className="menu-empty">No items found.</div>}
      </main>
      <BottomBar
        showAskMe={showAskMe}
        setShowAskPopup={setShowAskPopup}
        handleCartClick={handleCartClick}
        totalItems={totalItems}
        shareMenu={shareMenu}
        showContactInfo={showContactInfo}
        handleContactClick={handleContactClick}
      />
      {showDetails && selectedItem && (
        <ItemDetailsModal
          selectedItem={selectedItem}
          closeDetails={closeDetails}
          colorsState={colorsState}
          getCartQuantity={getCartQuantity}
          addToCart={addToCart}
          removeFromCart={removeFromCart}
        />
      )}
      {showCart && (
        <CartModal
          cart={cart}
          closeCart={closeCart}
          removeFromCart={removeFromCart}
        />
      )}
      {showAskPopup && (
        <AskPopupModal
          occasion={occasion} setOccasion={setOccasion}
          budget={budget} setBudget={setBudget}
          sharingStyle={sharingStyle} setSharingStyle={setSharingStyle}
          vegCount={vegCount} setVegCount={setVegCount}
          nonVegCount={nonVegCount} setNonVegCount={setNonVegCount}
          preferences={preferences} setPreferences={setPreferences}
          spiceLevel={spiceLevel} setSpiceLevel={setSpiceLevel}
          cuisine={cuisine} setCuisine={setCuisine}
          closeAskPopup={closeAskPopup}
          handleAskConfirm={handleAskConfirm}
        />
      )}
      {showContactModal && (
        <ContactModal
          closeContact={closeContact}
          workingHours={workingHours}
          socialLinks={socialLinks}
        />
      )}
      <style jsx>{`
        :root {
          --bg: ${colorsState.bg};
          --card: ${colorsState.card};
          --text: ${colorsState.text};
          --muted: ${colorsState.muted};
          --accent: ${colorsState.accent};
          --addBtnBg: ${colorsState.addBtnBg};
          --footerBg: ${colorsState.footerBg};
          --captionColor: ${colorsState.captionColor};
          --separatorColor: ${colorsState.separatorColor};
        }
        .menu-digital-menu-root {
          background: var(--bg);
          min-height: 100vh;
          color: var(--text);
          font-family: "Roboto", system-ui, -apple-system, "Segoe UI", "Helvetica Neue", Arial;
          padding-bottom: 120px;
          position: relative;
        }
        .menu-contact-btn {
          background: var(--accent);
          border: none;
          padding: 10px;
          border-radius: 8px;
          cursor: pointer;
          color: #111;
          font-weight: 700;
        }
        .menu-topbar {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          background: var(--card);
          border-bottom: 1px solid rgba(0,0,0,0.06);
          z-index: 200;
          text-align: center;
        }
        .menu-topbar-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 12px 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .menu-logo-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }
        .menu-logo { max-width: 180px; height: auto; }
        .menu-caption {
          font-size: ${menuCaptionSize};
          margin: 5px 0 0;
          color: var(--captionColor);
          font-weight: bold;
          text-align: center;
        }
        .menu-sticky-nav {
          position: sticky;
          top: 0;
          z-index: 190;
          background: var(--card);
          border-bottom: 1px solid rgba(0,0,0,0.04);
        }
        .menu-nav {
          display: flex;
          align-items: center;
          gap: 10px;
          overflow-x: auto;
          padding: 0 10px;
          scrollbar-width: thin; /* Firefox */
          -webkit-overflow-scrolling: touch;
        }
        .menu-nav::-webkit-scrollbar {
          height: 8px;
          background: #f0f0f0;
          display: block; /* Always show scrollbar */
        }
        .menu-nav::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 4px;
        }
        .menu-nav::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        .menu-nav-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 10px 0;
          display: flex;
          gap: 0;
          align-items: center;
          width: 100%;
        }
        .menu-category-pills {
          display: flex;
          gap: 8px;
          overflow-x: auto;
          padding-bottom: 10px;
          white-space: nowrap;
          -webkit-overflow-scrolling: touch;
          position: relative;
          width: 100%;
          justify-content: flex-start;
        }
        .menu-pill {
          background: #f8f9fa;
          border: 1px solid rgba(0, 0, 0, 0.08);
          border-radius: 999px;
          padding: 20px 32px;
          cursor: pointer;
          white-space: nowrap;
          font-size: 0.95rem;
          font-weight: 600;
          transition: all 0.25s ease;
          color: #333;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          flex-shrink: 0;
        }
        .menu-pill:hover {
          background: #fff;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
        }
        .menu-pill.active {
          background: var(--accent);
          color: #000;
          border: none;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
          transform: scale(1.05);
        }
        .menu-nav-arrow {
          background: white;
          border-radius: 50%;
          border: 1px solid rgba(0,0,0,0.1);
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          transition: background 0.2s ease;
        }
        .menu-nav-arrow:hover { background: #f0f0f0; }
        .menu-nav-arrow.left { margin-right: 0; }
        .menu-nav-arrow.right { margin-left: 0; }
        .menu-container {
          max-width: 1200px;
          margin: 20px auto;
          padding: 20px;
        }
        .menu-section-title {
          font-family: "Playfair Display", serif;
          color: var(--text);
          margin: 20px 0 10px;
          position: relative;
        }
        .menu-section-title::after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 0;
          width: 100%;
          height: 2px;
          background: linear-gradient(to right, #e0e7ff, #ffffff);
        }
        .menu-offers-row {
          display: flex;
          gap: 14px;
          overflow-x: auto;
          margin-bottom: 20px;
        }
        .menu-offer-card {
          min-width: 220px;
          border-radius: 10px;
          box-shadow: 0 6px 18px rgba(12,12,12,0.06);
          overflow: hidden;
          height: 80px;
          display: flex;
          align-items: center;
        }
        .menu-offer-body { padding: 10px; }
        .menu-offer-title { font-weight: 700; }
        .menu-offer-desc { color: var(--muted); font-size: 13px; }
        .menu-search-row { display: flex; gap: 12px; align-items: center; margin: 10px 0 20px; }
        .menu-search-input {
          flex: 1;
          padding: 10px 12px;
          border-radius: 10px;
          border: 1px solid rgba(0,0,0,0.06);
          background: var(--card);
          outline: none;
        }
        .menu-results-info { color: var(--muted); font-size: 13px; min-width: 90px; text-align: right; }
        .menu-diet-filter {
          display: flex;
          gap: 8px;
          margin-bottom: 20px;
          overflow-x: auto;
          padding-bottom: 10px;
        }
        .menu-diet-pill {
          background: #f8f9fa;
          border: 1px solid rgba(0, 0, 0, 0.08);
          border-radius: 999px;
          padding: 10px 20px;
          cursor: pointer;
          white-space: nowrap;
          font-size: 0.9rem;
          font-weight: 500;
          transition: all 0.25s ease;
          color: #333;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          flex-shrink: 0;
        }
        .menu-diet-pill:hover {
          background: #fff;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
        }
        .menu-diet-pill.active {
          background: var(--accent);
          color: #000;
          border: none;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
        }
        .menu-grid {
          display: grid;
          gap: 18px;
        }
        @media (max-width: 820px) {
          .menu-grid {
            gap: 10px;
          }
          .menu-item-card {
            width: 100%;
            margin: 0;
          }
          .menu-img-wrap { height: 100px; }
          .modal-inner img { height: 150px; }
          .menu-category-pills {
            display: flex;
            gap: 8px;
            overflow-x: auto;
            padding-bottom: 10px;
            white-space: nowrap;
            -webkit-overflow-scrolling: touch;
            position: relative;
            width: 100%;
            justify-content: flex-start;
          }
          .menu-pill {
            padding: 12px 24px;
          }
        }
        .menu-item-card {
          background: var(--card);
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 8px 30px rgba(12,12,12,0.06);
          cursor: pointer;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          display: flex;
          flex-direction: column;
        }
        .menu-item-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 40px rgba(0,0,0,0.1);
        }
        .menu-img-wrap { width: 100%; height: 120px; overflow: hidden; background: #eee; }
        .menu-img-wrap img { width: 100%; height: 100%; object-fit: cover; display: block; }
        .menu-card-body { padding: 12px 14px 14px; display: flex; flex-direction: column; gap: 8px; flex: 1; }
        .menu-item-title { margin: 0; font-size: 1.05rem; color: var(--text); display: flex; align-items: center; gap: 8px; font-weight: 700; }
        .menu-diet-dot { display: inline-block; width: 10px; height: 10px; border-radius: 50%; margin-left: 6px; }
        .menu-desc {
          color: var(--muted);
          font-size: 13px;
          margin: 0;
          line-height: 1.25;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .menu-meta { display: flex; align-items: center; justify-content: space-between; margin-top: auto; gap: 10px; }
        .menu-price { font-weight: 700; color: var(--text); }
        .menu-controls { display: flex; gap: 8px; align-items: center; }
        .menu-qty-btn {
          background: transparent;
          border: 1px solid rgba(0,0,0,0.06);
          border-radius: 8px;
          padding: 6px 10px;
          cursor: pointer;
        }
        .menu-qty { min-width: 18px; text-align: center; display: inline-block; }
        .menu-add-btn {
          width: 30px;
          height: 30px;
          max-width: 30px;
          border-radius: 8px;
          background: var(--addBtnBg);
          color: var(--accent);
          border: none;
          font-weight: 700;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 6px 16px rgba(0,0,0,0.15);
        }
        .menu-bottom-bar {
          position: fixed;
          bottom: 12px;
          left: 50%;
          transform: translateX(-50%);
          width: calc(100% - 40px);
          max-width: 1200px;
          background: var(--footerBg);
          padding: 10px;
          border-radius: 12px;
          display: flex;
          justify-content: space-between;
          gap: 12px;
          box-shadow: 0 10px 30px rgba(12,12,12,0.12);
          z-index: 300;
        }
        .menu-ask-btn { background: transparent; border: none; cursor: pointer; color: var(--muted); font-size: 16px; }
        .menu-cart-btn { background: var(--accent); border: none; padding: 10px 16px; border-radius: 8px; cursor: pointer; color: #111; font-weight: 700; }
        .share-btn { background: var(--accent); border: none; padding: 10px; border-radius: 8px; cursor: pointer; color: #111; font-weight: 700; }
        .modal {
          position: fixed;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0,0,0,0.5);
          z-index: 400;
        }
        .modal.fullscreen {
          background: var(--bg);
        }
        .modal-inner {
          background: var(--card);
          max-width: 600px;
          width: 90%;
          padding: 30px;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          position: relative;
          overflow-y: auto;
        }
        .modal.fullscreen .modal-inner {
          width: 100%;
          height: 100%;
          max-width: none;
          border-radius: 0;
          padding: 40px 20px;
          overflow-y: auto;
        }
        .modal-inner img { width: 100%; height: 250px; object-fit: cover; border-radius: 10px; margin-bottom: 20px; }
        .close-btn {
          position: absolute;
          top: 57px;
          right: 15px;
          background: none;
          border: none;
          font-size: 50px;
          cursor: pointer;
          color: var(--muted);
          font-weight: 900;
        }
        .menu-back-arrow {
          position: absolute;
          top: 57px;
          left: 15px;
          background: none;
          border: none;
          font-size: 51px;
          cursor: pointer;
          color: var(--text);
          font-weight: 900;
        }
        .menu-back-arrow:hover { color: var(--accent); }
        .close-btn:hover { color: var(--text); }
        .modal-actions .menu-controls {
          display: flex;
          gap: 15px;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        }
        .menu-cart-items {
          margin-top: 20px;
        }
        .menu-cart-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          padding: 10px;
          background: #f9f9f9;
          border-radius: 5px;
        }
        .menu-remove-btn {
          background: none;
          border: none;
          font-size: 18px;
          color: var(--muted);
          cursor: pointer;
        }
        .menu-remove-btn:hover { color: var(--text); }
        .menu-cart-total {
          font-weight: 700;
          margin-top: 20px;
          text-align: right;
          padding: 10px;
          background: #f0f0f0;
          border-radius: 5px;
        }
        .menu-empty-cart {
          text-align: center;
          padding: 40px 0;
        }
        .menu-empty-cart-image {
          width: 200px;
          height: auto;
          margin-bottom: 20px;
        }
        .menu-back-btn {
          background: #000000;
          color: #ffffff;
          padding: 10px 20px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-weight: bold;
          margin-top: 20px;
        }
        .menu-detail-title {
          text-align: center;
          font-size: 2rem;
          margin-bottom: 20px;
        }
        .menu-separator {
          border: 0;
          border-top: 2px solid var(--separatorColor);
          margin: 20px 0;
        }
        .menu-detail-image {
          display: block;
          margin: 0 auto;
        }
        .menu-detail-section {
          margin-bottom: 20px;
        }
        .menu-detail-section h4 {
          margin-bottom: 10px;
          color: var(--text);
          font-size: 1.2rem;
        }
        .menu-detail-section p {
          margin: 0;
          color: var(--muted);
          font-size: 1rem;
          line-height: 1.5;
        }
        .menu-page-footer {
          background: #f0f0f0;
          padding: 20px;
          text-align: center;
          color: var(--muted);
          position: fixed;
          bottom: 0;
          width: 100%;
          z-index: 200;
          transform: translateY(100%);
          transition: transform 0.3s ease-in-out;
        }
        .menu-page-footer.visible {
          transform: translateY(0);
        }
        .menu-contact-section, .menu-hours-section {
          margin-bottom: 20px;
        }
        .menu-hours-section td {
          padding: 5px 10px;
          border: 1px solid rgba(0,0,0,0.1);
        }
        .menu-hours-section td {
          padding: 5px 10px;
          border: 1px solid rgba(0,0,0,0.1);
        }
        .social-links {
          display: flex;
          justify-content: center;
          gap: 15px;
          margin-bottom: 20px;
        }
        .social-links a {
          font-size: 24px;
          color: var(--accent);
        }
        .menu-copyright {
          margin-top: 10px;
        }
        .menu-product-of {
          margin-top: 10px;
        }
        .menu-product-of a {
          color: var(--text);
          text-decoration: none;
        }
        .menu-product-of a:hover {
          text-decoration: underline;
        }
        .menu-empty { padding: 40px; text-align: center; color: var(--muted); }
        .menu-ask-inner {
          max-width: 700px;
          padding: 20px;
        }
        .menu-ask-section {
          margin-bottom: 20px;
        }
        .menu-ask-section h4 {
          font-size: 1.1rem;
          margin-bottom: 5px;
        }
        .menu-ask-section p {
          font-size: 0.95rem;
          color: var(--muted);
          margin-bottom: 10px;
        }
        .menu-ask-input, .menu-ask-select {
          width: 100%;
          padding: 10px;
          border: 1px solid rgba(0,0,0,0.1);
          border-radius: 8px;
          background: #f9f9f9;
          font-size: 1rem;
        }
        .menu-ask-diet-counts {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .menu-ask-number-input {
          width: 60px;
          padding: 10px;
          border: 1px solid rgba(0,0,0,0.1);
          border-radius: 8px;
          background: #f9f9f9;
          font-size: 1rem;
        }
        .menu-ask-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          margin-top: 20px;
        }
        .menu-ask-cancel {
          background: #f0f0f0;
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          cursor: pointer;
          color: var(--text);
        }
        .menu-ask-confirm {
          background: var(--accent);
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          cursor: pointer;
          color: #111;
          font-weight: 700;
        }
        .loader-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
        }
        .loader {
          display: flex;
          gap: 10px;
        }
        .dot {
          width: 20px;
          height: 20px;
          background: #000;
          border-radius: 50%;
          animation: bounce 1s infinite;
        }
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
        .error-message-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          width: 100vw;
          position: fixed;
          top: 0;
          left: 0;
          background: #fff;
          z-index: 500;
        }
        .error-message {
          font-size: 1.5rem;
          color: red;
          text-align: center;
          padding: 20px;
          border: 1px solid red;
          border-radius: 8px;
          max-width: 80%;
        }
        /* Main Category */
        .main-category-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: var(--text);
          text-transform: uppercase;
          flex: 1;
          margin: 0;
          transition: color 0.3s ease;
        }
        .main-category-title:hover {
          color: var(--accent);
        }
        /* Sub Category */
        .sub-category-title {
          font-size: 1.2rem;
          font-weight: 500;
          color: var(--muted);
          flex: 1;
          margin: 0;
          transition: color 0.3s ease;
        }
        .sub-category-title:hover {
          color: var(--text);
        }
        /* Shared Header Style */
    /* Shared Header Style */
.category-header, 
.sub-category-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 14px 18px;
  border-radius: 12px;
  margin: 12px 0;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

/* Category header (main group like "BAR") */
.category-header {
  background: #b3d2af;              /* Darker, stronger green */
  border: 1px solid #8ab57f;
  font-size: 1.15rem;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--text);
}

/* Sub-category header (like "Beer", "Gin") */
.sub-category-header {
  background: #e8f7e8;              /* Light green */
  border: 1px solid #cce5cc;
  padding-left: 34px;               /* Indentation for nesting */
  border-left: 4px solid var(--accent);
  font-size: 1rem;
  font-weight: 600;
  color: var(--text);
}

/* Hover states */
.category-header:hover {
  background: #a0c0a0;
}
.sub-category-header:hover {
  background: #d8edd8;
}

/* Chevron icon animation */
.expand-icon {
  font-size: 1.4rem;
  color: var(--text);
  transition: transform 0.3s ease, color 0.3s ease;
}
.category-header.open .expand-icon,
.sub-category-header.open .expand-icon {
  transform: rotate(90deg);
  color: var(--accent);
}


        .menu-contact-section {
          margin-top: 20px;
          padding: 15px;
          background: #fff;
          border-radius: 12px;
          margin-right: 50px;
          box-shadow: 0 2px 6px rgba(0,0,0,0.05);
        }
        .menu-contact-section h4 {
          margin-bottom: 10px;
          font-size: 1.1rem;
          font-weight: 600;
          color: #2c3e50;
        }
        .social-icons {
          margin-top: 15px;
          display: flex;
          justify-content: center;  /* Center horizontally */
          gap: 25px;                /* Space between icons */
        }
        .social-icons a {
          font-size: 2rem;          /* Bigger icons */
          color: #555;              /* Default gray */
          transition: transform 0.2s ease, color 0.3s ease;
        }
        .social-icons a:hover {
          transform: scale(1.2);    /* Slight zoom effect */
        }
        /* Brand colors */
        .social-icons a.instagram:hover { color: #E1306C; }  /* Instagram pink */
        .social-icons a.facebook:hover { color: #1877F2; }   /* Facebook blue */
        .social-icons a.twitter:hover { color: #1DA1F2; }    /* Twitter blue */
        .social-icons a.whatsapp:hover { color: #25D366; }   /* WhatsApp green */
        .expand-icon {
          font-size: 1.5rem;
          color: var(--text);
        }
        @media (max-width: 820px) {
          .main-category-title {
            font-size: 1.5rem;
          }
          .sub-category-title {
            font-size: 1.2rem;
          }
          .category-header, .sub-category-header {
            padding: 8px;
          }
        }

        .menu-close-btn {
          position: fixed;
          top: 12px;
          right: 12px;
          background: none;
          border: none;
          font-size: 2rem;
          cursor: pointer;
          color: var(--text);
          z-index: 999;
        }
        .menu-close-btn:hover {
          color: var(--accent);
        }
      `}</style>
    </div>
  );
}